import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Paper, Typography } from '@mui/material';
import { cerrarSesionAccion } from '../../redux/UsuarioDucks'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './PerfilUsuario.module.css'
import user from '../../img/user.jpeg'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
import { obtenerUserPorEmail, obtenerCliente } from '../../redux/UsuarioDucks'
import {
    actualizarLogin
} from '../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { useState } from 'react';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../redux/AppDucks';
import { obtenerClienteConDetalle } from '../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import DetalleClienteComponent from '../UsuarioAtencionACliente/ModuloConsulta/DetalleClienteComponent';
function PerfilUsuario() {
    const dispatch = useDispatch()

    const currentUser = useSelector(store => store.Usuario.data)
    const usuarioCompleto = useSelector(store => store.Usuario.user)

    const cliente = useSelector(store => store.Usuario.cliente)

    React.useEffect(() => {
        let email = currentUser.user[0].user
        let d = dispatch(obtenerUserPorEmail(email))

    }, [])
    React.useEffect(async () => {
        let data = await dispatch(obtenerCliente(currentUser.user?.[0].id))
        /*console.log('los datos de data es ', data)
        if (data) {
            dispatch(actualizarLoadingApp_true());
            await dispatch(obtenerClienteConDetalle(data?.data?.data?.idcliente));
            //props.history.push("/DetalleCliente");
            dispatch(actualizarLoadingApp_false());
        }*/
    }, [])
    /*React.useEffect(async() => {
        console.log(cliente, 'liente')
        if (cliente?.idcliente) {
            dispatch(actualizarLoadingApp_true());
            await dispatch(obtenerClienteConDetalle(cliente.idcliente));
            //props.history.push("/DetalleCliente");
            dispatch(actualizarLoadingApp_false());
        }
    }, [cliente])*/

    const [correo, setCorreo] = useState('')
    const [contraseña, setContraseña] = useState('')
    const [verContraseña, setVerContraseña] = useState('')

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const handleOpenModal = () => {
        setCorreo(usuarioCompleto[0].usuario)
        setOpenModal(true)

    }
    const handleCloseModal = () => {
        setCorreoVacio(false)
        setContraseñaVacio(false)
        setVerificarVacio(false)
        setContraseñasIguales(false)
        setCorreo('')
        setContraseña('')
        setVerContraseña('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-description" >
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" placeholder="Correo Electronico"
                                    className={`form-control `}
                                    value={correo}
                                    onChange={e => setCorreo(e.target.value)}
                                    disabled
                                />
                                <label className="label-black" htmlFor="floatingInput">Correo Electrónico</label>
                                {correoVacio && <span className='text-danger'>El correo electronico esta vacio</span>}
                            </div>
                            <div className="form-floating mb-3">
                                <input type="password" id="floatingInput" placeholder="Correo Electronico"
                                    className={`form-control `}
                                    value={contraseña}
                                    onChange={e => setContraseña(e.target.value)}
                                />
                                <label className="label-black" htmlFor="floatingInput">Nueva Contraseña</label>
                                {contraseñaVacio && <span className='text-danger'>La contraseña esta vacia</span>}
                            </div>
                            <div className="form-floating mb-3">
                                <input type="password" id="floatingInput" placeholder="Verificar Contraseña"
                                    className={`form-control `}
                                    value={verContraseña}
                                    onChange={e => setVerContraseña(e.target.value)}
                                />
                                <label className="label-black" htmlFor="floatingInput">Verificar Contraseña</label>
                                {verificarVacio && <span className='text-danger'>La  verificación de la contraseña esta vacia</span>}
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            {contraseñasIguales && <span className='text-danger text-center'>La contraseña no coincide intente nuevamente</span>}
                            <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div classNameName='row'>
                            <button className='btn btn-success' style={{ margin: '5%' }} onClick={() => actualizarUsuario()}>CONTINUAR</button>
                            <button className='btn btn-dark ' onClick={() => handleCloseModal()}>CANCELAR</button>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    const [correoVacio, setCorreoVacio] = useState(false)
    const [contraseñaVacio, setContraseñaVacio] = useState(false)
    const [verificarVacio, setVerificarVacio] = useState(false)
    const [contraseñasIguales, setContraseñasIguales] = useState(false)
    const actualizarUsuario = async () => {
        if (correo === '' || contraseña === '' || verContraseña === '') {
            if (correo === '') setCorreoVacio(true)
            if (contraseña === '') setContraseñaVacio(true)
            if (verContraseña === '') setVerificarVacio(true)
        } else {
            setCorreoVacio(false)
            setContraseñaVacio(false)
            setVerificarVacio(false)
            if (contraseña === verContraseña) {
                let data = { idlogin: usuarioCompleto[0].idlogin, usuario: correo, password: contraseña }
                await dispatch(actualizarLogin(data))
                setContraseñasIguales(false)
                handleCloseModal(true)
            } else {
                setContraseñasIguales(true)
            }

        }
    }

    return (
        <Fragment>
            <div className={`${estilos.box} row `}>
                <div className='col-md-4'><img src={user} alt="" className={`${estilos.imagen}`} /></div>
                <div className='col-md-8'>
                    {cliente?.nombrerazonsocial != null && cliente?.nombrerazonsocial != undefined &&
                        <div className='col-md-12'><br /><b>Nombre/Razón social: </b> {cliente?.nombrerazonsocial}</div>}
                    <div className='col-md-12'><br /><b>Usuario:</b> {usuarioCompleto[0]?.usuario} </div>
                    <div className='col-md-12'><br /><b>Contraseña: </b> °°°°°°°°°°°°°°°°°°°</div>{/*usuarioCompleto[0]?.password.substring(0, 25)*/}
                    <div className='col-md-12'><br /><b>Fecha de Registro:</b> {usuarioCompleto[0]?.fechainscripcion !== null ? usuarioCompleto[0]?.fechainscripcion.substring(0, 10) : ''}</div>
                </div>
                <div className='col-md-12 text-center'><button className='btn btn-success' onClick={() => handleOpenModal()}>Modificar</button><br /> </div>
            </div>
            {(usuarioCompleto?.[0]?.tipousuario?.idtipousuario == 2) &&
                <div className={`${estilos.consulta} row `}>
                    <DetalleClienteComponent></DetalleClienteComponent>
                </div>
            }
            {modalComponent()}
        </Fragment >
    )
}

export default PerfilUsuario
